import { findBrandColorByHex } from 'modules/BrandDefinition';
import { useEffect, useRef } from 'react';
import * as Constants from 'const';
import * as Models from 'models';
import { isDefaultBrandStyleAvailable } from 'utils/brandStyles';
import { TextEditorHook } from './TextEditorHook';
import useCell from './useCell';
import useStyles from './useStyles';

type HookProps = {
  editMode: boolean;
  document: Models.TextComponentMap;
  relation: Models.LayeredRegularRelationMap<Models.TextRelationStyles>;
  activeLayer: Constants.Layer;
  sectionStyles: Models.MasterScreen.SectionStylesMap;
  colors: Models.BrandColorsList;
  brandStyles: Models.BrandStylesMap;
};

export default function useEditMode(
  props: HookProps,
  editorHook: TextEditorHook,
  stylesHook: ReturnType<typeof useStyles>,
  cellHook: ReturnType<typeof useCell>,
  setBrandStyle: (style: Models.BrandStyleMap) => void,
  storeText: () => void,
): void {
  const { editMode } = props;
  const isMountedRef = useRef(false);

  useEffect((): void => {
    if (!isMountedRef.current) {
      isMountedRef.current = true;

      return;
    }
    const { document, relation, activeLayer, brandStyles, colors } = props;

    cellHook.resetHeight();

    if (editMode) {
      // useDefaultStyles
      const noComponentAssigned = !relation.getIn(['documentId', activeLayer]) || !document;

      const brandStyleId = relation.getIn(['styles', activeLayer, 'brandStyleId']);
      // NOTE: brand style and font color must be ignored if there is no document assigned
      if (!brandStyleId && noComponentAssigned) {
        if (isDefaultBrandStyleAvailable(brandStyles, props.sectionStyles)) {
          setBrandStyle(brandStyles.get(Constants.Styles.DefaultTextBrandStyle));
          stylesHook.ensureStylesToBeKept();
        } else {
          editorHook.setters.fontColor(
            findBrandColorByHex(colors, Constants.DefaultCustomStyle.FONT_COLOR),
          );
          stylesHook.ensureStylesToBeKept();
        }
      }
      editorHook.returnFocusToEditor();
      cellHook.resetCellWidhtAndHeightChange();
    } else {
      storeText();
    }
  }, [editMode]);
}
